import React, {useState, useEffect, useRef, useMemo} from 'react';
import Head from 'next/head';
import styled from 'styled-components'

import PageWrapper from 'components/pageWrapper';
import ContentWrapper from 'components/contentWrapper';
import WhiteBox from 'components/blocks/blockPartials/whiteBox';
import Icon from 'components/icons/icon';
import Grid from 'components/blocks/blockPartials/grid';
import Card from 'components/blocks/blockPartials/card';
import Pagination from 'components/pagination';

import config from 'settings/config';
import seo from 'utils/seo';
import theme, {bp, color} from 'settings/theme';

import storyblokService from 'services/storyblokService.js';
import StoryblokClient from 'storyblok-js-client';

import {date as dateLens} from 'utils/lenses';


const lenses = {date:dateLens};

let Storyblok = new StoryblokClient({
    accessToken: config.storyBlok.publicToken
});


const Page = (props) => {
    
  const [currentPage, setCurrentPage] = useState(props.slug ? parseInt(props.slug as string) : 1);

  useEffect(() => {
    setCurrentPage(props.slug ? parseInt(props.slug as string) : 1);
  }, [props.slug]);

  // Get content from supplied StoryBlok story
  const content = useMemo(() => {
    return props.pageData?.content;
  }, [props.pageData]);

  const seoContent = content.seo;

  return (

      <>

        <Head>
          <title>{seo.createTitle(seoContent?.title)}</title>
          <meta name="description" content={seoContent?.description} />
        </Head>

        <StyledPage className="blogListPage">

          <PageWrapper>
            
            {/* Intro */}
            <WhiteBox className="spacingBottom">
              <ContentWrapper>

                <div className="content spacingTop spacingBottom">

                  <div className="blogListPage-titleLayout">
                    <div className="blogListPage-titleLayout-title">
                      <h1>Our Blog</h1>
                    </div>
                    <div className="blogListPage-titleLayout-social">
                      <a href="https://www.facebook.com/wheelfreedom" target="_blank" className="blogListPage-facebook-icon">
                        <Icon iconName="facebook-circle" className="blogListPage-facebook-icon" />
                      </a>
                      <a href="https://x.com/wheelfreedom" target="_blank" className="blogListPage-x-icon">
                        <Icon iconName="x-circle" className="blogListPage-x-icon"  />
                      </a>
                    </div>
                  </div>
                  
                  {content.intro &&
                    <div className="content" dangerouslySetInnerHTML={{__html: Storyblok.richTextResolver.render(content.intro)}} />
                  }
                    
                </div>

              </ContentWrapper>
            </WhiteBox>

            {/* Pagination  */}
            <div className="blogListPage-pagination spacingBottomHalf">
              <Pagination 
                totalCount={props.meta.totalCount || 0} 
                itemsPerPage={config.blog.resultsPerPage}
                currentPage={currentPage}
                pagesToShow={5}
                showDirectionButtons={true}
                showLimitButtons={true}
                urlMode="path"
                pathTemplate="/blog/{page}"
                pathTemplateFirstPage="/blog"
              ></Pagination>
            </div>
            

            {/* Card Grid */}
            {props.records && props.records.length > 0 &&
              <ContentWrapper>
                <Grid className="spacingBottom">
                  {props.records.map(item => (
                    <Card
                      key={item.id}
                      mainImageUrl={item.content.image?.filename || item.content.image}
                      title={item.content.title}
                      subtitle={lenses.date(item.content.date)}
                      text={item.content.summary}
                      link={{
                        linktype: 'story',
                        cached_url: item.full_slug
                      }}
                      linkText="READ ARTICLE"
                    />
                  ))}
                </Grid>
              </ContentWrapper>
            }

          </PageWrapper>

        </StyledPage>

        {storyblokService.bridge()}

      </>
  
  );

}


export default Page





// Styles
const StyledPage = styled.div`

  /* Top Section */
  .blogListPage-titleLayout{

    display: flex;
    width: 100%;
    justify-content: space-between;
    
  }

  .blogListPage-titleLayout-social{

    display: flex;

    a{

      margin-left: 5px;
      transition: all 0.15s ease-out;

      &:hover{
        filter: brightness(1.2);
      }

    }

  }

  .blogListPage-facebook-icon{
    svg {
      fill: ${color.facebook};
    }
  }

  .blogListPage-x-icon{
    svg {
      fill: #000;
    }
  }


  /* Pagination */
  .blogListPage-pagination{
    display: flex;
    align-items: center;
    justify-content: center;
  }


  @media (min-width: ${bp(3)}) {
      
    .blogListPage-titleLayout-social{

      a{
        margin-left: 8px;
      }

      .icon{
        width: 32px;
        height: 32px;
      }

    }
      
  }


`;



